import assignWith from 'lodash/assignWith';
import pickBy from 'lodash/pickBy';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { ActiveIncidentsState } from '../types.tsx';
import fetchActiveIncidents from './fetch-active-incidents/index.tsx';

const mergeActiveIncidents =
	(activeIncidentsInCache: ActiveIncidentsState): Action<ActiveIncidentsState> =>
	({ getState, setState }) => {
		const activeIncidentsInState = getState();
		const filteredActiveIncidentsInCache: ActiveIncidentsState = pickBy(
			activeIncidentsInCache,
			(activeIncident) =>
				activeIncident !== undefined && !activeIncident.error && !activeIncident.loading,
		);

		setState(
			assignWith(
				{},
				activeIncidentsInState,
				filteredActiveIncidentsInCache,
				(activeIncidentInState, activeIncidentInCache): ActiveIncidentsState => {
					if (
						activeIncidentInState === undefined ||
						activeIncidentInCache.loadedAt > activeIncidentInState.loadedAt
					) {
						return activeIncidentInCache;
					}
					return activeIncidentInState;
				},
			),
		);
	};

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { fetchActiveIncidents, mergeActiveIncidents };
